/* eslint-disable react/jsx-one-expression-per-line */
import React, { useEffect, useState } from 'react';
// @ts-ignore
import { useSelector } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';
// @ts-ignore
import { Card } from '@els/els-react--card';
// @ts-ignore
import { SingleSelect } from '@els/els-react--select';
// @ts-ignore
import { generatePath } from 'react-router';
// @ts-ignore
import ClinicalSkills from '../../../../assets/img/0099-stethoscope.svg';
// @ts-ignore
import PatientEducation from '../../../../assets/img/patient-education.svg';
import { hasSucceeded } from '../../../../../libs/utils/constants/async-status';
import {
    selectTypeOfContentForClient,
    selectTypeOfContentForClientAsyncStatus,
} from '../../home-selector';
import Routes from '../../../../constants/routes';
import AutoSuggestComponent from '../../../../components/auto-suggest/auto-suggest';
import { selectAllActiveSkillsDetails } from '../../../search/search-selector';

const SearchBox = (props: any) => {
    const { baseClassName, firstName, search } = props;
    const history = useHistory();
    const licensedContentTypes: { [key: string]: boolean } = useSelector(
        selectTypeOfContentForClient
    );
    const contentTypesAsyncStatus = useSelector(
        selectTypeOfContentForClientAsyncStatus
    );
    const allActiveSkillsDetails = useSelector(selectAllActiveSkillsDetails);
    const { ecrId } = useParams<{ ecrId: string }>();

    const allContentTypes: { [key: string]: boolean } = {
        'Clinical Skills': false,
        'Patient Education': false,
    };

    if (hasSucceeded(contentTypesAsyncStatus)) {
        if (licensedContentTypes.Skill) {
            allContentTypes['Clinical Skills'] = true;
        }
        if (licensedContentTypes.PE) {
            allContentTypes['Patient Education'] = true;
        }
    }

    const contents = Object.keys(allContentTypes)
        .filter((key) => allContentTypes[key])
        .map((key) => key);

    // the new SingleSelect component needs an array of objects with label and value properties.
    const contentOptions = contents.map((c) => ({ label: c, value: c }));

    const getDefaultContentType = () => {
        if (contents.includes('Clinical Skills')) {
            return 'Clinical Skills';
        }
        return contents[0] || '';
    };

    const [selectedContentType, setSelectedContentType] = useState(
        getDefaultContentType()
    );

    useEffect(() => {
        if (contents.length > 0 && !contents.includes(selectedContentType)) {
            setSelectedContentType(getDefaultContentType());
        }
    }, [selectedContentType, contents]);

    const handleRedirectToSearch = (search: string) => {
        const contentType = selectedContentType || getDefaultContentType();
        const redirectLink = `${generatePath(Routes.SEARCH, {
            ecrId,
        })}?keyword=${search}&content_type=${contentType}`;
        history.push(`${redirectLink}`);
        window.scrollTo(0, 0);
    };

    const handleSelect = (option: { label: string; value: string }) => {
        setSelectedContentType(option.value);
    };

    return (
        <Card className={`${baseClassName}__top-content-search`}>
            <h1
                className={`${baseClassName}__top-content-search-title`}
                tabIndex={-1}
                id="content"
            >
                Welcome {firstName}
            </h1>
            <p className={`${baseClassName}__top-content-search-sub-title`}>
                Search across all content including:
            </p>
            <div className={`${baseClassName}__top-content-search-contents`}>
                {licensedContentTypes.Skill && (
                    <div
                        className={`${baseClassName}__top-content-search-contents-label`}
                    >
                        <img
                            src={ClinicalSkills}
                            alt=""
                            width={25}
                            height={25}
                        />
                        <p className="u-els-font-size-h4">Clinical Skills</p>
                    </div>
                )}
                {licensedContentTypes.PE && (
                    <div
                        className={`${baseClassName}__top-content-search-contents-label`}
                    >
                        <img
                            src={PatientEducation}
                            alt=""
                            width={25}
                            height={25}
                        />
                        <p className="u-els-font-size-h4">Patient Education</p>
                    </div>
                )}
            </div>
            {hasSucceeded(contentTypesAsyncStatus) && (
                <div className={`${baseClassName}__top-content-search-bar`}>
                    {licensedContentTypes.PE && (
                        <div
                            className={`${baseClassName}__top-content-search-bar-button`}
                        >
                            <SingleSelect
                                options={contentOptions}
                                selectedOptions={[selectedContentType]}
                                label="Select Content Type"
                                onSelect={(e: any) => handleSelect(e)}
                                required
                                shouldHideLabel
                                shouldSelectionWrap
                                className="u-docs-position-relative u-docs-z-index"
                            />
                        </div>
                    )}
                    <AutoSuggestComponent
                        onHandleSearchClick={handleRedirectToSearch}
                        keyword={search}
                        allActiveSkillsDetails={allActiveSkillsDetails}
                        contentTypeLicensedByClient={licensedContentTypes}
                        contentTypeLicensedAsyncStatus={contentTypesAsyncStatus}
                    />
                </div>
            )}
        </Card>
    );
};

export default SearchBox;
